<div>
<span  class="category-label pull-right" [ngStyle]="getCategoryColor()" >{{categoryLabel}}</span>
</div>
<p-panel header="Category of Information" styleClass="panel-header" class="category-panel">
    <div *ngFor="let subcategory of category">
      <p-accordion [multiple]="true">
        <p-accordionTab [selected]="true" [disabled]="true">
          <p-header>
              <span>{{subcategory.displayName}}</span>
              <button *ngIf="!isViewer" class='pull-right attachment-btn pointer' (click)="displayAttachmentModal(subcategory.value)" pTooltip="Add Attachment(s)" tooltipPosition="bottom" tooltipStyleClass="subheader-item-tooltip">
                <img src="assets/images/attachment-icon-white.svg">
              </button>
           </p-header>
          <p-table auto="upload-table" *ngIf="subcategory.files.length" [value]="subcategory.files"  styleClass="category-table"
            selectionMode="single" >
            <ng-template pTemplate="header">
              <tr class="title-head">
                <th class="attachment-name">Attachment Name</th>
                <th class="attachment-description">Attachment Description</th>
                <th class="attachment-details">Attachment Details</th>
                <th ></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-attachment>
              <tr [pSelectableRow]="attachment">
                <td class="title-column" valign="top">
                  <div class='attachment-pointer'>
                    <div class="attachment-icon-container">
                      <img class="attachment-icon" class="height-20" [src]="iconImageSrc(attachment)" tooltipStyleClass="strategies-tooltip"
                        [alt]="altText(attachment)" [pTooltip]="altText(attachment)">
                    </div>
                    <span class="attachment-name-container" (click)="onClickAttachmentName(attachment)">
                        <a class="pointer underline attachment-name">{{attachment.name}}</a>
                    </span>
                  </div>
                </td>
                <td valign="top">
                  <div class="attachment-pointer">
                    {{attachment.description}}
                  </div>
                </td>
                <td valign="top">
                    <div class="attachmentDetails">
                        <span class="bold">{{attachment.createdUserFirstName}} {{attachment.createdUserLastName}}</span>
                      <span><i>{{formattedDate(attachment.createdDateTime)}}</i></span>
                        </div>
                </td>
                <!-- *ngIf="!isEditItemDisabled && !isDeleteItemDisabled" -->
                <td class="actions-icons pull-right" valign="top">
                  <div>
                  <button
                    *ngIf="!isViewer"
                    auto="upload-edit-btn"
                    class="fa fa-pencil pointer"
                    pTooltip="Edit Attachment(s)"
                    tooltipStyleClass="subheader-item-tooltip"
                    tooltipPosition="bottom"
                    tooltipEvent="hover"
                    appendTo="body"
                    (click)="displayEditAttachmentModal(subcategory.value, attachment)"
                  >
                  <!--  [disabled]="isEditItemDisabled" -->
                  </button>
                  <button
                    *ngIf="!isViewer"
                    auto="upload-delete-btn"
                    [attr.attachment]="attachment"
                    class="fa fa-trash pointer"
                    pTooltip="Delete Attachment(s)"
                    tooltipStyleClass="subheader-item-tooltip"
                    tooltipPosition="bottom"
                    tooltipEvent="hover"
                    (click)="displayDeleteModal(attachment, attachment.name)"
                  >
                  <!-- [disabled]="isDeleteItemDisabled" -->
                  </button>
                </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-accordionTab>

      </p-accordion>
    </div>
  </p-panel>
